(() => {
  // src/js/custom.js
  Element.prototype._addEventListener = Element.prototype.addEventListener;
  Element.prototype.addEventListener = function(a, b, c) {
    if (c == void 0) c = false;
    this._addEventListener(a, b, c);
    if (!this.eventListenerList) this.eventListenerList = {};
    if (!this.eventListenerList[a]) this.eventListenerList[a] = [];
    this.eventListenerList[a].push({ listener: b, useCapture: c });
  };
  Element.prototype.getEventListeners = function(a) {
    if (!this.eventListenerList) this.eventListenerList = {};
    if (a == void 0) return this.eventListenerList;
    return this.eventListenerList[a];
  };
  Element.prototype.clearEventListeners = function(a) {
    if (!this.eventListenerList) this.eventListenerList = {};
    if (a == void 0) {
      for (var x in this.getEventListeners()) this.clearEventListeners(x);
      return;
    }
    var el = this.getEventListeners(a);
    if (el == void 0) return;
    for (var i = el.length - 1; i >= 0; --i) {
      var ev = el[i];
      this.removeEventListener(a, ev.listener, ev.useCapture);
    }
  };
  Element.prototype._removeEventListener = Element.prototype.removeEventListener;
  Element.prototype.removeEventListener = function(a, b, c) {
    if (c == void 0) c = false;
    this._removeEventListener(a, b, c);
    if (!this.eventListenerList) this.eventListenerList = {};
    if (!this.eventListenerList[a]) this.eventListenerList[a] = [];
    for (var i = 0; i < this.eventListenerList[a].length; i++) {
      if (this.eventListenerList[a][i].listener == b, this.eventListenerList[a][i].useCapture == c) {
        this.eventListenerList[a].splice(i, 1);
        break;
      }
    }
    if (this.eventListenerList[a].length == 0) delete this.eventListenerList[a];
  };
  (() => {
    window.addEventListener("load", async () => {
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop)
      });
      if (!params.form_type || !location.hash || location.hash !== "#newsletter-form-main-popup") {
        return;
      }
      document.getElementById("newsletter-notifications-footer").scrollIntoView();
    });
    window.addEventListener("load", async () => {
      const sidebar = document.querySelector(".header-sidebar");
      const sidebarPanel = JSON.parse(sessionStorage.getItem("sidebarPanel"));
      const chevrons = document.querySelectorAll(
        ".header-sidebar__linklist-chevron"
      );
      const buttons = document.querySelectorAll(
        ".header-sidebar__linklist-button"
      );
      buttons.forEach(
        (button) => button.addEventListener("click", (e) => {
          const chevron = e.target.nextElementSibling;
          if (!chevron) {
            return;
          }
          sessionStorage.setItem(
            "sidebarPanel",
            JSON.stringify(chevron.getAttribute("aria-controls"))
          );
        })
      );
      if (!sidebarPanel) {
        return;
      }
      await sidebar.show(false);
      for (const chevron of chevrons) {
        if (chevron.getAttribute("aria-controls") === sidebarPanel) {
          chevron.click();
        }
      }
      sessionStorage.removeItem("sidebarPanel");
    });
    document.querySelectorAll('a[href^="#modal:"]').forEach((anchor) => {
      anchor.addEventListener("click", (e) => {
        e.preventDefault();
        const modalId = anchor.getAttribute("href").replace("#modal:", "");
        const modal = document.getElementById(modalId);
        if (modal == null) {
          return;
        }
        modal.show();
      });
    });
    document.addEventListener("theme:predictive-search:updated", () => {
      if (!window.iWish) {
        return;
      }
      window.iWish.init();
    });
  })();
  document.addEventListener("quick-buy-modal:show", (e) => {
    if (!window.iWish) {
      return;
    }
    console.log("init iWish");
    window.iWish.init();
  });
  var drawerAvailability = () => {
    const availabilityCheckbox = document.querySelector(
      'input[type="checkbox"][name="filter.v.availability"]'
    );
    if (!availabilityCheckbox) {
      return;
    }
    availabilityCheckbox.setAttribute("checked", true);
  };
  var fixCartDrawerCache = () => {
    const cartDrawerButtons = document.querySelectorAll(
      '[aria-controls="cart-drawer"]'
    );
    cartDrawerButtons.forEach(
      (button) => button.addEventListener("click", () => {
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      })
    );
  };
  var imageView = () => {
    document.querySelectorAll('input[name="images-view"]').forEach((input) => {
      input.addEventListener("change", ({ currentTarget }) => {
        if (!currentTarget.checked) {
          return;
        }
        document.querySelector(".collection__main").setAttribute("data-view", currentTarget.value);
        if (currentTarget.value === "dressed") {
          return;
        }
        document.querySelectorAll(".product-gallery__carousel").forEach((carousel) => {
          carousel.select(0);
        });
      });
    });
  };
  var events = ["DOMContentLoaded", "facet:updated"];
  events.forEach((event) => {
    document.addEventListener(event, () => {
      drawerAvailability();
      fixCartDrawerCache();
      imageView();
    });
  });
})();
